import React, { useEffect, useState } from 'react';
import { api } from '../utils/api';

const currentMonth = () => {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
};

const duration = (totals) => `${totals?.ore || 0}h ${String(totals?.minuti || 0).padStart(2, '0')}m`;

export default function RegistroServizioRiepilogo({ congregazioneId }) {
  const [mese, setMese] = useState(currentMonth);
  const [search, setSearch] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setRows([]);
    setLoading(true);
    setError('');
    if (!congregazioneId) {
      setError('Seleziona una congregazione.');
      setLoading(false);
      return () => { active = false; };
    }
    api.get('/registro-servizio/admin/riepilogo', { params: { mese, congregazione_id: congregazioneId } })
      .then(({ data }) => { if (active) setRows(data.proclamatori || []); })
      .catch(() => { if (active) setError('Impossibile caricare il riepilogo mensile.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [mese, congregazioneId]);

  const visible = rows.filter((row) =>
    `${row.nome} ${row.cognome}`.toLocaleLowerCase('it').includes(search.toLocaleLowerCase('it')) ||
    `${row.cognome} ${row.nome}`.toLocaleLowerCase('it').includes(search.toLocaleLowerCase('it'))
  );

  return (
    <section className="bg-white shadow rounded-lg p-4 sm:p-6" aria-label="Riepilogo mensile proclamatori">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div className="min-w-0">
          <h2 className="text-lg font-semibold text-gray-900">Rapporto mensile complessivo</h2>
          <p className="mt-1 text-sm text-gray-600">Per ogni proclamatore della congregazione d’origine: servizio libero/altro, postazioni locali e Opera Porto. I totali manuali già inseriti prevalgono e non vengono sommati di nuovo.</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0">
          <label className="text-sm font-medium text-gray-700 sm:w-40">Mese
            <input type="month" value={mese} onChange={(event) => setMese(event.target.value)} className="mt-1 block w-full rounded-md border-gray-300 text-base sm:text-sm" />
          </label>
          <label className="text-sm font-medium text-gray-700 sm:w-60">Cerca proclamatore
            <input type="search" value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Nome o cognome" className="mt-1 block w-full rounded-md border-gray-300 text-base sm:text-sm" />
          </label>
        </div>
      </div>
      {loading ? <p className="mt-6 text-sm text-gray-500">Caricamento…</p> : null}
      {error ? <p role="alert" className="mt-6 text-sm text-red-700">{error}</p> : null}
      {!loading && !error && visible.length === 0 ? <p className="mt-6 text-sm text-gray-500">Nessun proclamatore trovato.</p> : null}
      {!loading && !error && visible.length > 0 ? (
        <div className="mt-6 overflow-x-auto rounded-lg border border-gray-200">
          <table className="min-w-[760px] w-full text-sm text-left">
            <thead className="bg-gray-50 text-gray-600"><tr>
              <th scope="col" className="px-4 py-3">Proclamatore</th>
              <th scope="col" className="px-4 py-3">Libero / altro</th>
              <th scope="col" className="px-4 py-3">Postazioni</th>
              <th scope="col" className="px-4 py-3">Opera Porto</th>
              <th scope="col" className="px-4 py-3">Totale mensile</th>
              <th scope="col" className="px-4 py-3">Stato</th>
            </tr></thead>
            <tbody className="divide-y divide-gray-100">
              {visible.map((row) => <tr key={row.id}>
                <th scope="row" className="px-4 py-3 font-medium text-gray-900">{row.cognome} {row.nome}</th>
                <td className="px-4 py-3">{duration(row.sourceTotals.libero)}</td>
                <td className="px-4 py-3">{duration(row.sourceTotals.postazioni)}</td>
                <td className="px-4 py-3">{duration(row.sourceTotals.porto)}</td>
                <td className="px-4 py-3 font-semibold text-gray-900">
                  {duration(row.finalTotals)}
                  <span className="mt-1 block text-xs font-normal text-gray-600">
                    LDC {row.finalTotals.ore_ldc || 0} · Studi {row.finalTotals.studi || 0} · Pubblicazioni {row.finalTotals.pubblicazioni || 0}
                  </span>
                </td>
                <td className="px-4 py-3 text-gray-600">{row.chiuso ? 'Chiuso' : row.manuale ? 'Manuale' : 'Automatico'}</td>
              </tr>)}
            </tbody>
          </table>
        </div>
      ) : null}
    </section>
  );
}
